/**
*
*/
<template>
    <nav-page-view title="集中抄表" :isLoading="isLoading">
        <div class="content">
            <div class="house-info">
                <van-cell :title="house.name" :value="house.readMeterTime" :label="'计费月份 ' + house.rentMonth" />
            </div>

            <van-form>
                <van-sticky :offset-top="46">
                    <div class="head-row">
                        <div class="head-col-1">房号</div>
                        <div class="head-col-2">上期读数</div>
                        <div class="">本期读数</div>
                    </div>
                </van-sticky>
                <div v-for="(vo, index) in formData.roomList" :key="index" class="row">
                    <div class="row-col-1">
                        {{ vo.roomName }}
                    </div>
                    <div class="row-col-2">
                        <div class="row-sub water">
                            <!--                    水表-->
                            <div class="row-col-3">水</div>
                            <div class="row-col-4">
                                <!--                                <input type="number">-->
                                <van-field v-model="vo.waterMeterLast" type="tel" placeholder="水表" />
                            </div>
                            <div class="row-col-4">
                                <van-field v-model="vo.waterMeter" type="tel" placeholder="水表" />
                            </div>
                        </div>
                        <div class="row-sub electricity">
                            <!--                    电表-->
                            <div class="row-col-3">电</div>
                            <div class="row-col-4"><van-field v-model="vo.electricityMeterLast" type="tel" placeholder="电表" /></div>
                            <div class="row-col-4"><van-field v-model="vo.electricityMeter" type="tel" placeholder="电表" /></div>
                        </div>
                    </div>
                </div>
                <van-field
                    v-model="formData.remark"
                    rows="2"
                    autosize
                    label="备注"
                    type="textarea"
                    maxlength="50"
                    placeholder="请输入备注"
                    show-word-limit
                />
                <van-field name="discountRental"
                           label="房租折扣"
                           placeholder="请输入房租折扣" v-model="formData.discountRental" type="number" />

            </van-form>
        </div>
        <template slot="footer">
            <div style="padding: 15px">
                <van-button round block type="info" @click="onSubmit">提交</van-button>
            </div>
        </template>
    </nav-page-view>
</template>

<script>
import {copyValue, goRouterPage} from "@/common/utils";
    import AreaList from "@/common/area"
    import cache from "@/common/cache";
    import messageBox from "@/common/messageBox";
    import NavPageView from "@/components/NavPageView";
    import typeUtils from "@/common/typeUtils";

    export default {
        name: "index",
        components:{
            NavPageView
        },
        data() {
            this.phoneRules = [
                { required: true, message: '请填写承租人手机号' },
                { validator: this.phoneValidator, message: '手机号格式错误' },
            ];
            this.numberRules = [
                { required: true, message: '请输入数字' },
                { validator: this.numberValidator, message: '数字格式错误' },
            ];
            return {
                isLoading: false,
                house: {
                    id: "",    //房屋ID
                    name: "",      //房屋名
                    readMeterTime: "", // 抄表日期
                    rentMonth: "",     //计费月份
                },
                formData: {
                    roomList: [],
                    houseId: '',    //房屋ID
                    readMeterTime: '',  // 抄表日期
                    rentMonth: "",     //计费月份
                    remark: "",     //备注
                    discountRental: ""  // 房租折扣 值为 0<= N <=1, 当等于1时，不打折
                },
                testValue: '',
                showArea: false,
                curAreaItem: null,
                areaList: AreaList, // 数据格式见 Area 组件文档
                showCalendar: false,
                autoSaveInterval: null,
            }
        },
        created() {
            if (this.hasBeforeSave()) {
                if (this.$queryParams().useBeforeSave === '1') {
                    this.useBeforeAutoSave();
                    this.startAutoSave();
                } else {
                    // messageBox.showConfirm('', '是否使用上次未提交的数据？').then(() => {
                    //     // on confirm
                    //     this.useBeforeAutoSave();
                    //     this.startAutoSave();
                    // }).catch(() => {
                    //     // on cancel
                    //     this.initData();
                    // });
                    this.initData();
                }
            } else {
                this.initData();
            }
        },
        mounted() {
            // this.login();
        },
        // activated() {
        //     console.log("activated useCache: ", this.$route.meta.useCache)
        //     if (this.hasBeforeSave()) {
        //         if (this.$queryParams().useBeforeSave === '1') {
        //             this.useBeforeAutoSave();
        //             this.startAutoSave();
        //         } else {
        //             // messageBox.showConfirm('', '是否使用上次未提交的数据？').then(() => {
        //             //     // on confirm
        //             //     this.useBeforeAutoSave();
        //             //     this.startAutoSave();
        //             // }).catch(() => {
        //             //     // on cancel
        //             //     this.initData();
        //             // });
        //             this.initData();
        //         }
        //     } else {
        //         this.initData();
        //     }
        //     // if(!this.$route.meta.useCache){
        //
        //         // this.getRooms();
        //         // this.initData();
        //     // }
        // },
        // deactivated(){
        //     this.stopAutoSave();
        // },
        beforeDestroy() {
            this.stopAutoSave();
        },
        methods: {
            initData(){
                this.isLoading = true;
                copyValue(this.house, this.$queryParams());
                this.formData.houseId = this.house.id;
                this.formData.readMeterTime = this.house.readMeterTime;
                this.formData.rentMonth = this.house.rentMonth;
                this.formData.roomList = [];
                const p1 = this.$get('/rooms/list', {houseId: this.house.id});
                const p2 = this.$get('/rental/lastMeter', {houseId: this.house.id});
                const p3 = this.$get('/rooms/remoteReadHouseMeter', {houseId: this.house.id});
                Promise.all([p1, p2, p3]).then(resList=>{
                    console.log(resList);
                    const rooms = resList[0].data;
                    const lastMeterList = resList[1].data;
                    const curMeterList = resList[2].data;
                    let lastMeter = {};
                    let curMeter = {};
                    for (let meter of lastMeterList){
                        // room_id:
                        // electricity_meter:
                        // water_meter:
                        lastMeter[meter.room_id] = meter;
                    }
                    for (let meter of curMeterList) {
                        curMeter[meter.roomId] = meter;
                    }

                    let lastMeterVo;
                    for(let room of rooms){
                        let mItem = this.initRoom();
                        mItem.roomName = room.name;
                        mItem.roomId = room.id;
                        lastMeterVo = lastMeter[room.id]
                        if(lastMeterVo){
                            mItem.waterMeterLast = lastMeterVo.water_meter;
                            mItem.electricityMeterLast = lastMeterVo.electricity_meter;
                            mItem.lastMeterDate = lastMeterVo.meter_date;
                            mItem.lastElectricityAmount = lastMeterVo.electricity_amount;
                            mItem.lastWaterAmount = lastMeterVo.water_amount;
                        }
                        if (curMeter[room.id]) {
                            mItem.waterMeter = curMeter[room.id].waterMeter;
                            mItem.electricityMeter = curMeter[room.id].electricityMeter;
                        }
                        this.formData.roomList.push(mItem);
                    }
                    // console.log()
                    this.startAutoSave();
                    this.isLoading = false;
                });
            },
            stopAutoSave(){
                if (this.autoSaveInterval) {
                    clearInterval(this.autoSaveInterval);
                    this.autoSaveInterval = null;
                }
            },
            startAutoSave() {
                this.stopAutoSave();
                this.autoSaveInterval = setInterval(() => {
                    cache.setStorage(cache.getKeys().meterInput, {
                        house: this.house,
                        formData: this.formData,
                        time: (new Date()).getTime()
                    })
                }, 1000);
            },
            useBeforeAutoSave(){
                let beforeSave = cache.getStorage(cache.getKeys().meterInput);
                if(beforeSave){
                    this.house = beforeSave.house;
                    this.formData = beforeSave.formData;
                }
            },
            hasBeforeSave() {
                return cache.hasBeforeMeterInputSave();
            },
            // getLastMeter(){
            //     return this.$get('/rental/lastMeter', {houseId: this.house.id}).then(({data})=>{
            //         // this.rooms = data.content
            //         for(let room of data){
            //
            //         }
            //     })
            // },
            getRooms(){
                return this.$get('/rooms/list', {houseId: this.house.id}).then(({data})=>{
                    // this.rooms = data.content
                    for(let room of data){
                        let mItem = this.initRoom();
                        mItem.roomName = room.name;
                        mItem.roomId = room.id;
                        this.formData.roomList.push(mItem);
                    }
                })
            },
            initRoom() {
                return {
                    roomId: '', // 房ID
                    roomName: '',   // 房间名
                    electricityMeterLast: '',  //上期电表度数
                    electricityMeter: '',  //本期电表度数
                    waterMeterLast: '',  //上期水表度数
                    waterMeter: '',  //本期水表度数
                    lastMeterDate: '',  //上期抄表日期
                    lastElectricityAmount: '',  //上期电表度数
                    lastWaterAmount: '',  //上期水表度数
                }
            },

            // 校验函数返回 true 表示校验通过，false 表示不通过
            phoneValidator(val) {
                return /1\d{10}/.test(val);
            },
            numberValidator(val){
              return true
            },
            isCheckLimit(room){
                if(['总表'].includes(room.roomName)){
                    return false;
                }else {
                    return true;
                }
            },
            onSubmit(values){
                console.log('onSubmit', values);
                console.log('formData:', JSON.stringify(this.formData));
                // let postData = JSON.parse(JSON.stringify(this.formData));
                // for (let item of postData.custom){
                //     for (let upItem of item.uploader){
                //         item.imgList.push(upItem.url);
                //     }
                //     delete item.uploader;
                // }
                // console.log('postData:', JSON.stringify(postData));

                // 数据校验
                let errMsg = '';
                for (let room of this.formData.roomList) {
                    if (typeUtils.isNumberStr(room.electricityMeter) && typeUtils.isNumberStr(room.electricityMeterLast)) {
                        if (Number(room.electricityMeter) < Number(room.electricityMeterLast)) {
                            errMsg += room.roomName + ' 电表度数小于上月； ';
                        }
                        if (this.isCheckLimit(room)) {
                            let electricityAmount = Number(room.electricityMeter) - Number(room.electricityMeterLast);
                            let electricityDiff = electricityAmount - room.lastElectricityAmount;
                            if (electricityDiff > 300) {
                                errMsg += room.roomName + ' 用电量比上月多300度； ';
                            } else if (electricityDiff < -300) {
                                errMsg += room.roomName + ' 用电量比上月少300度； ';
                            }
                        }
                    }
                    if (typeUtils.isNumberStr(room.waterMeter) && typeUtils.isNumberStr(room.waterMeterLast)) {
                        if (Number(room.waterMeter) < Number(room.waterMeterLast)) {
                            errMsg += room.roomName + ' 水表读数小于上月； ';
                        }
                        if (this.isCheckLimit(room) && Number(room.waterMeter) - Number(room.waterMeterLast) > 30) {
                            let waterAmount = Number(room.waterMeter) - Number(room.waterMeterLast);
                            let waterDiff = waterAmount - room.lastWaterAmount
                            if (waterDiff > 20) {
                                errMsg += room.roomName + ' 用水量比上月多20吨； ';
                            } else if (waterDiff < -20) {
                                errMsg += room.roomName + ' 用水量比上月少20吨； ';
                            }
                        }
                    }
                }

                messageBox.showConfirm('', errMsg + '是否确认提交？').then(() => {
                    // on confirm
                    this.isLoading = true;
                    this.$jsonPost('/rental/meterInput', this.formData).then(()=>{
                        this.$toast.success('添加成功');
                        this.stopAutoSave();
                        cache.setStorage(cache.getKeys().meterInput, null);
                        goRouterPage(this, '/unpayBill', {}, true);
                        // this.onClickLeft();
                    }).finally(()=>{
                        this.isLoading = false;
                    })
                }).catch(() => {
                    // on cancel

                });
            },
            onClickLeft() {
                this.$goBack();
            },
            onClickRight() {
                this.$toast('按钮');
                // Toast('按钮');
            },
            goToRental(id){
                console.log(id);
                // this.$routers.push("rooms");
                this.$router.push({path:'rental'});
            }
        }
    }
</script>

<style scoped lang="less">
    .content{
        background-color: #f7f8fa;
        .add-custom{
            position: relative;
            background-color: #ffffff;
            margin-top: 10px;
            height: 48px;
            line-height: 48px;
            padding-left: 16px;
            color: #8f8f94;
            /*margin-bottom: 10px;*/
            .add-custom-btn{
                position: absolute;
                right: 16px;
                top: 6px;
                padding-left: 10px;
                height: 36px;
            }
        }
        .house-info{
            margin-bottom: 10px;
        }
    }
    .item-text{
        font-size: 12px;
        color: #8f8f94;
        margin-top: 8px;
    }
    .van-nav-bar{
        background-color: #409EFF;
        .van-nav-bar__title{
            color: #ffffff;
        }
    }
    .head-row{
        display: flex;
        flex-direction: row;
        justify-content: left;
        padding: 10px 0;
        background-color: #42b983;
        color: #fff;
    }
    .col{
        /*float: left;*/
    }
    .head-col-1{
        width: 42%;
        padding-left: 16px;
        box-sizing: border-box;
    }
    .head-col-2{
        width: 31%;
    }
    .row{
        display: flex;
        flex-direction: row;
        background: #fff;
        margin-bottom: 10px;
        .row-col-1{
            width: 30%;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #969799;
        }
        .row-col-2{
            width: 70%;
        }
        .row-col-3{
            width: 12%;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .row-col-4{
            width: 44%;
        }
        .row-sub{
            display: flex;
            flex-direction: row;
            position: relative;
            &:not(:last-child)::after{
                position: absolute;
                box-sizing: border-box;
                content: ' ';
                pointer-events: none;
                right: 0;
                bottom: 0;
                left: 0px;
                border-bottom: 1px solid #ebedf0;
                -webkit-transform: scaleY(.5);
                transform: scaleY(.5);
            }
        }
        .water{
            color: #1989fa;
            /deep/ .van-field__control{
                color: #1989fa;
            }
        }
        .electricity{
            color: #F44336;
            /deep/ .van-field__control{
                color: #F44336;
            }
        }
    }
</style>
